import React from 'react';
import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
  const updated = new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="legal-back" data-testid="privacy-back-home">← Back to Home</Link>
        <h1>Privacy Policy</h1>
        <p className="legal-updated">Last updated: {updated}</p>

        <p>
          PBNJ Backflow Testing ("we," "us," or "our") is committed to protecting your privacy.
          This policy explains what information we collect, how we use it, and how we protect it.
        </p>

        <h2>Information We Collect</h2>
        <p>
          When you request or book a backflow test, we collect the information you provide, including
          your name, phone number, email address (optional), and service address. We may also collect
          appointment details and any notes you submit through our booking form.
        </p>

        <h2>How We Use Your Information</h2>
        <p>
          We use your information solely to schedule and complete your backflow test, communicate with
          you about your appointment, submit required test results to your city, and provide customer
          support. We do not use your information for unrelated marketing.
        </p>

        <h2>SMS / Text Messaging</h2>
        <p>
          SMS text messaging is <strong>optional and is not a condition of booking an appointment or
          receiving service</strong>. If you check the optional consent box on our booking form, you
          agree to receive SMS text messages from PBNJ Backflow Testing about your appointment
          (confirmations, scheduling, and reminders). Message and data rates may apply, and message
          frequency varies. You can opt out at any time by replying STOP, or reply HELP for help.
          We only send transactional appointment messages — we do <strong>not</strong> send marketing,
          advertising, or promotional texts of any kind, and we will never use your phone number for
          such purposes.
          <strong> Phone numbers and SMS opt-in consent are never shared with or sold to third parties,
          and are not used for third-party marketing under any circumstances.</strong>
        </p>

        <h2>How We Protect and Share Information</h2>
        <p>
          We use secure technology to protect your information during transmission and storage. We do
          not sell or rent your personal data. We only share information with trusted service providers
          strictly as needed to deliver a service you requested (for example, calendar scheduling, email,
          or SMS delivery), and those providers are required to keep your information confidential. We may
          disclose information if required by law.
        </p>

        <h2>Contact Us</h2>
        <p>
          Questions about this policy? Call or text us at <strong>(469) 505-4321</strong> or email{' '}
          <a href="mailto:info@pbnjbackflowtesting.com">info@pbnjbackflowtesting.com</a>.
        </p>
      </div>
    </div>
  );
}
